import { Result } from '@sapphire/result';
import {
  ADVANCED_FILTER_TYPE,
  FEOT_QUOTA_GROUP_LARGER_THAN_PACE_MESSAGE,
  MC_MESSAGES,
} from '@ps/survey-utils';

import { ChildSwitchContext } from './child-switch.context';

export interface ChildSwitchViolation {
  readonly message: string;
  readonly severity: 'error' | 'warning';
}

export type ChildSwitchValidation = (
  context: ChildSwitchContext,
) => Result<void, ChildSwitchViolation>;

export const manualProcessingSettled: ChildSwitchValidation = ({
  isManualProcessingEnabled,
  isFeasibilityLoading,
}) =>
  isManualProcessingEnabled && isFeasibilityLoading
    ? Result.err({
        message: MC_MESSAGES.MANUAL_PROCESSING_IN_FLIGHT,
        severity: 'warning',
      })
    : Result.ok();

export const respondentStatusSelected: ChildSwitchValidation = ({
  advancedFilters,
  isRespondentStatusFilterEnabled,
}) =>
  isRespondentStatusFilterEnabled &&
  advancedFilters.type === ADVANCED_FILTER_TYPE.EXCLUDE &&
  !advancedFilters.respondentStatuses.length
    ? Result.err({
        message: MC_MESSAGES.NO_RESPONDENT_STATUS_SELECTED,
        severity: 'error',
      })
    : Result.ok();

export const uniqueLinksUploaded: ChildSwitchValidation = ({
  isUniqueLinksEnabled,
  uniqueLinksCount,
}) =>
  isUniqueLinksEnabled && !uniqueLinksCount
    ? Result.err({
        message: MC_MESSAGES.UNIQUE_LINKS_NOT_UPLOADED,
        severity: 'error',
      })
    : Result.ok();

export const feotAgainstQuota: ChildSwitchValidation = (context) =>
  context.hasFeotQuotaViolation
    ? Result.err({
        message: FEOT_QUOTA_GROUP_LARGER_THAN_PACE_MESSAGE,
        severity: 'error',
      })
    : Result.ok();
